import {HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
  AddSyncMemberResponse,
  AddSyncOrganizationResponse,
  AddSyncProfileResponse,
  AddSyncProviderResponse,
  Configuration,
  EditSyncMemberResponse,
  EditSyncOrganizationResponse,
  EditSyncProfileResponse,
  EditSyncProviderResponse,
  GetSyncMembersResponse,
  GetSyncOrganizationResponse,
  GetSyncProfilesResponse,
  RemoveSyncMemberResponse,
  RemoveSyncOrganizationResponse,
  RemoveSyncProfileResponse,
  RemoveSyncProviderResponse,
  SynchronizationServiceInterface,
  SyncMember,
  SyncOrganization,
  SyncProfileAbsence,
  SyncProviderAbsence,
  SyncProviderDirectory,
  SyncProviderPresence
} from '@gt-api';
import {MockData} from '@testhelper/mock-data';
import {Observable, of} from 'rxjs';

@Injectable()
export class SynchronizationServiceStub implements SynchronizationServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  addSyncMember1(
    organization?: string,
    login?: string,
    body?: SyncMember,
    extraHttpRequestParams?: any
  ): Observable<AddSyncMemberResponse> {
    return of({code: 200});
  }

  addSyncOrganization1(
    organization?: string,
    login?: string,
    body?: SyncOrganization,
    extraHttpRequestParams?: any
  ): Observable<AddSyncOrganizationResponse> {
    return of({code: 200});
  }

  addSyncProfile1(
    organization?: string,
    login?: string,
    body?: SyncProfileAbsence,
    extraHttpRequestParams?: any
  ): Observable<AddSyncProfileResponse> {
    return of({code: 200});
  }

  addSyncProvider1(
    organization?: string,
    login?: string,
    body?: SyncProviderAbsence,
    extraHttpRequestParams?: any
  ): Observable<AddSyncProviderResponse> {
    return of({code: 200});
  }

  editSyncMember1(
    organization?: string,
    login?: string,
    body?: SyncMember,
    extraHttpRequestParams?: any
  ): Observable<EditSyncMemberResponse> {
    return of({code: 200});
  }

  editSyncOrganization1(
    organization?: string,
    login?: string,
    body?: SyncOrganization,
    extraHttpRequestParams?: any
  ): Observable<EditSyncOrganizationResponse> {
    return of({code: 200});
  }

  editSyncProfile1(
    organization?: string,
    login?: string,
    body?: SyncProfileAbsence,
    extraHttpRequestParams?: any
  ): Observable<EditSyncProfileResponse> {
    return of({code: 200});
  }

  editSyncProvider1(
    organization?: string,
    login?: string,
    body?: SyncProviderAbsence,
    extraHttpRequestParams?: any
  ): Observable<EditSyncProviderResponse> {
    return of({code: 200});
  }

  getSyncMembers1(organization?: string, login?: string, extraHttpRequestParams?: any): Observable<GetSyncMembersResponse> {
    return of({code: 200, members: [{login: MockData.login, organization: MockData.organization}]});
  }

  getSyncOrganization1(organization?: string, login?: string, extraHttpRequestParams?: any): Observable<GetSyncOrganizationResponse> {
    return of({
      code: 200,
      syncOrganization: {absenceProviders: [{id: 0, username: 'test', password: '', owaUrl: '', domain: '', exchangeVersion: ''}]}
    });
  }

  getSyncProfiles1(organization?: string, login?: string, extraHttpRequestParams?: any): Observable<GetSyncProfilesResponse> {
    return of({code: 200});
  }

  removeSyncMember1(
    organization?: string,
    login?: string,
    body?: SyncMember,
    extraHttpRequestParams?: any
  ): Observable<RemoveSyncMemberResponse> {
    return of({code: 200});
  }

  removeSyncOrganization1(
    organization?: string,
    login?: string,
    body?: SyncOrganization,
    extraHttpRequestParams?: any
  ): Observable<RemoveSyncOrganizationResponse> {
    return of({code: 200});
  }

  removeSyncProfile1(
    organization?: string,
    login?: string,
    profileId?: number,
    extraHttpRequestParams?: any
  ): Observable<RemoveSyncProfileResponse> {
    return of({code: 200});
  }

  removeSyncProvider1(
    organization?: string,
    login?: string,
    body?: SyncProviderAbsence,
    extraHttpRequestParams?: any
  ): Observable<RemoveSyncProviderResponse> {
    return of({code: 200});
  }

  removeSyncMemberAbsence1(
    organization?: string,
    login?: string,
    extraHttpRequestParams?: any
  ): Observable<RemoveSyncMemberResponse> {
    return of({code: 200});
  }

  removeSyncProviderAbsence1(
    id: number,
    organization?: string,
    login?: string,
    extraHttpRequestParams?: any
  ): Observable<RemoveSyncProviderResponse> {
    return of({code: 200});
  }

  removeSyncProviderDirectory1(
    id: number,
    organization?: string,
    login?: string,
    extraHttpRequestParams?: any
  ): Observable<RemoveSyncProviderResponse> {
    return of({code: 200});
  }

  addSyncProviderDirectory1(
    organization?: string,
    login?: string,
    body?: SyncProviderDirectory,
    extraHttpRequestParams?: any
  ): Observable<AddSyncProviderResponse> {
    return of({code: 200});
  }

  editSyncProviderDirectory1(
    organization?: string,
    login?: string,
    body?: SyncProviderDirectory,
    extraHttpRequestParams?: any
  ): Observable<EditSyncProviderResponse> {
    return of({code: 200});
  }

  addSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, extraHttpRequestParams?: any): Observable<AddSyncProviderResponse> {
    return of({code: 200});
  }
  editSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, extraHttpRequestParams?: any): Observable<EditSyncProviderResponse> {
    return of({code: 200});
  }
  removeSyncProviderPresence1(id: number, organization?: string, login?: string, extraHttpRequestParams?: any): Observable<RemoveSyncProviderResponse> {
    return of({code: 200});
  }
}
